
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TomlBox',

  props: {
    toml: {
      type: String,
      required: true
    },
    primaryActionDisabled: {
      type: Boolean,
      default: false
    },
    secondaryActionDisabled: {
      type: Boolean,
      default: false
    },
    isActivated: {
      type: Boolean,
      default: false
    },
    canBeActivated: {
      type: Boolean,
      default: false
    },
    canViewerUpgrade: {
      type: Boolean,
      default: false
    },
    isCommitPossible: {
      type: Boolean,
      default: false
    },
    isAutofixEnabled: {
      type: Boolean,
      default: false
    },
    isOnboardFlow: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    activateRepo(): void {
      this.$emit('activateRepo')
    },

    toggleNextSteps(): void {
      this.$emit('toggleNextSteps')
    },

    commitConfigToVCS(createPullRequest = false): void {
      this.$emit('commitConfig', createPullRequest)
    },

    commitGSRConfigToVCS(): void {
      this.$emit('commitGSR')
    },

    triggerAdHocRun(): void {
      this.$emit('triggerAdHocRun')
    }
  }
})
